export default "__VITE_ASSET__CfBUWFlo__"